import Cart from "../index"
import { connect } from "react-redux"
import { Dispatch, RootState } from "@redux/store"
import {
  selectCartQuantity,
  selectCheckoutLink,
  selectCouponCodeApplied,
  selectAutomaticDiscountApplied,
  selectAutomaticDiscountAllocations,
} from "@redux/selectors"
import { getLocalStorage } from "@utils/storage"
import { RECENTLY_VIEWED_PRODUCTS_KEY } from "@constants/storageKeys"

interface ownProps {
  isOpen: boolean
  onRequestClose: () => void
}

const mapState = (state: RootState, ownProps: ownProps) => ({
  items: state.checkout.localCheckout?.items || [],
  subtotal: state.checkout.localCheckout?.subtotal || "",
  total: state.checkout.localCheckout?.total || "",
  cartCount: selectCartQuantity(state),
  checkoutLink: selectCheckoutLink(state),
  showPromoToast: state.checkout.showPromoToast,
  recentItems: getLocalStorage(RECENTLY_VIEWED_PRODUCTS_KEY) || [],
  couponCodeApplied: selectCouponCodeApplied(state),
  automaticDiscounts: state.discounts.automaticDiscounts,
  automaticDiscountApplied: selectAutomaticDiscountApplied(state),
  automaticDiscountAllocations: selectAutomaticDiscountAllocations(state),
  discountedProductsData: state.discounts.discountedProductsData,
  discountedProductsInventoryData:
    state.discounts.discountedProductsInventoryData,
  customerLocation: state.customer.customerLocation,
})

const mapDispatch = (dispatch: Dispatch) => ({
  addToCart: dispatch.checkout.addToCart,
  onUpdateCartItem: dispatch.checkout.updateCart,
  onUpdateDiscount: dispatch.checkout.updateDiscount,
  onRemoveDiscount: () => {
    // @ts-ignore
    dispatch.checkout.updateDiscount(undefined)
  },
})

// @ts-ignore
export default connect(mapState, mapDispatch)(Cart)
